import { createApp } from 'vue';

import router from '@/router/index.js';

import 'amfe-flexible';
import Vant from 'vant';
import 'vant/lib/index.css';

import VConsole from 'vconsole';
const _vconsole = new URL(window.location.href).search.includes('vconsole=1')
if(process.env.VUE_APP_VCONSOLE == 'true' || _vconsole) var vConsole = new VConsole();

import App from './App.vue';
const app = createApp(App)
app.use(router)
app.use(Vant)
app.mount('#app')